import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RapoarteActivitateComponent } from './rapoarte-activitate.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';



@NgModule({
    declarations: [
        RapoarteActivitateComponent
    ],
    imports: [
        CommonModule, MaterialModule, ReactiveFormsModule, FormsModule
    ],
    exports: [RapoarteActivitateComponent],
})
export class RapoarteActivitateModule { }
